import React from "react";
import { HashRouter, Route, Switch } from "react-router-dom";

import SignInPage from "app/pages/SignInPage";
// import SignUpPage from "app/pages/SignUpPage";
import SignOutPage from "app/pages/SignOutPage";
import MastersPage from "app/pages/MastersPage";
import ChatPage from "app/pages/ChatPage";
import ServicesPage from "app/pages/ServicesPage";
import RecordsPage from "app/pages/RecordsPage";
import PageContentPage from "app/pages/PageContentPage";
import NotFoundPage from "app/pages/NotFoundPage";
import CurrentPageContent from "app/pages/CurrentPageContent";
import ServiceCategoriesPage from "app/pages/ServiceCategoriesPage";
import MessagesPage from "app/pages/MessagesPage";
import UsersPage from "app/pages/UsersPage";
import GalleryPage from '../../pages/GalleryPage';

const App: React.FC = () => {
  // у всех пользовательских страниц есть LayoutUser который фетчит пользователя
  // и в случае ошибки делает редирект
  console.log("О, привет 👋, а я тебя знаю!");
  return (
    <HashRouter>
      <Switch>
        <Route path="/" exact component={RecordsPage} />
        <Route path="/signin" exact component={SignInPage} />
        {/* <Route path="/signup" exact component={SignUpPage} /> */}
        <Route path="/masters" exact component={MastersPage} />
        <Route
          path="/serviceCategories"
          exact
          component={ServiceCategoriesPage}
        />
        <Route path="/users" exact component={UsersPage} />
        <Route path="/services" exact component={ServicesPage} />
        <Route path="/signout" exact component={SignOutPage} />
        <Route path="/pages/:id" exact component={CurrentPageContent} />
        <Route path="/gallery" exact component={GalleryPage} />
        <Route path="/messages/page=:page" exact component={MessagesPage} />
        <Route path="/chat" exact component={ChatPage} />
        <Route path="/pages" exact component={PageContentPage} />
        <Route component={NotFoundPage} />
      </Switch>
    </HashRouter>
  );
};

export default App;
